import P from '../../pages';
import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { defaultMessages } from '../../../../libs/i18n/default'
import FormHeader from './FormHeader'
import Redirector from './Redirector'
import Button from 'react-bootstrap/lib/Button'
import { Redirect } from 'react-router-dom';
import CheckboxOrRadioGroup from './CheckboxOrRadioGroup';
import Alert from './Alert';
import ButtonGroup from './ButtonGroup';
import Form from 'react-bootstrap/lib/Form';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormControl from 'react-bootstrap/lib/FormControl';
import Paw from 'react-icons/lib/fa/paw'
import CustomFormGroup from './CustomFormGroup';
import ProfileElementField from './ProfileElementField';
import { pageValid, executeValidations, shouldValidateProfileElement, toggleValidations } from '../../validator';
import { setProfileElementsFromState, handleSelection, changeState } from '../../utilities';

class Pets extends React.Component {
  constructor(props) {
    super(props)
    let pets = setProfileElementsFromState(this.props.profileElements, '', 'lifestyle', 'pets')
    let validatePets = shouldValidateProfileElement(this, 'pets')
    let petTypes = setProfileElementsFromState(this.props.profileElements, [], 'lifestyle', 'pet_types')
    let validatePetTypes = pets && validatePets && shouldValidateProfileElement(this, 'pet_types')
    let petTypesOther = setProfileElementsFromState(this.props.profileElements, '', 'lifestyle', 'pet_types_other')
    let validatePetTypesOther = validatePetTypes && petTypes.includes('Other')
    let petIndoorsOutdoors = setProfileElementsFromState(this.props.profileElements, '', 'lifestyle', 'pet_indoors_outdoors')
    let validatePetIndoorsOutdoors = pets && validatePets && shouldValidateProfileElement(this, 'pet_indoors_outdoors')
    let petHypoallergenic = setProfileElementsFromState(this.props.profileElements, '', 'lifestyle', 'pet_hypoallergenic')
    let validatePetHypoallergenic = pets && validatePets && shouldValidateProfileElement(this, 'pet_hypoallergenic')
    let petsNotes = setProfileElementsFromState(this.props.profileElements, '', 'lifestyle', 'pets_notes')
    let validatePetsNotes = pets && validatePets && shouldValidateProfileElement(this, 'pets_notes')
    this.state = {
      pets: { val: pets, validationKey: validatePets ? 'profile_elements_lifestyle_pets' : '' },
      petTypes: { val: petTypes, validationKey: validatePetTypes ? 'profile_elements_lifestyle_pet_types' : '' },
      petTypesOther: { val: petTypesOther, validationKey: validatePetTypesOther ? 'profile_elements_lifestyle_pet_types_other' : '' },
      petIndoorsOutdoors: { val: petIndoorsOutdoors, validationKey: validatePetIndoorsOutdoors ? 'profile_elements_lifestyle_pet_indoors_outdoors' : '' },
      petHypoallergenic: { val: petHypoallergenic, validationKey: validatePetHypoallergenic ? 'profile_elements_lifestyle_pet_hypoallergenic' : '' },
      petsNotes: { val: petsNotes, validationKey: validatePetsNotes ? 'profile_elements_lifestyle_pets_notes' : '' },
      petTypesSelections: this.props.localProfileElements.elements.lifestyle.pet_types_selections,
      petIndoorsOutdoorsSelections: this.props.localProfileElements.elements.lifestyle.pet_indoors_outdoors_selections
    }
    this.submit = this.submit.bind(this);
    this.back = this.back.bind(this);
    this.changeState = this.changeState.bind(this);
    this.handlePetTypesSelection = this.handlePetTypesSelection.bind(this);
    this.handlePetIndoorsOutdoorsSelection = this.handlePetIndoorsOutdoorsSelection.bind(this);
  }

  componentWillMount() {
    executeValidations(this)
  }

  changeState = async (id, val) => {
    if (id == 'pets') {
      toggleValidations(this, val, 'pet_types', 'petTypes', 'profile_elements_lifestyle_pet_types')
      toggleValidations(this, val, 'pets_notes', 'petsNotes', 'profile_elements_lifestyle_pets_notes')
      toggleValidations(this, val && this.state.petTypes.val.includes('Other'), 'pet_types', 'petTypesOther', 'profile_elements_lifestyle_pet_types_other')
      toggleValidations(this, val, 'pet_indoors_outdoors', 'petIndoorsOutdoors', 'profile_elements_lifestyle_pet_indoors_outdoors')
      toggleValidations(this, val, 'pet_hypoallergenic', 'petHypoallergenic', 'profile_elements_lifestyle_pet_hypoallergenic')
    }
    changeState(this, id, val)
  }

  handlePetTypesSelection(e) {
    let newPetTypes = handleSelection(this.state.petTypes.val, e.target.value)
    toggleValidations(this, newPetTypes.includes('Other'), 'pet_types', 'petTypesOther', 'profile_elements_lifestyle_pet_types_other')
    this.changeState('petTypes', newPetTypes)
  }

  handlePetIndoorsOutdoorsSelection(e) {
    let newPetIndoorsOutdoors = handleSelection(this.state.petIndoorsOutdoors.val, e.target.value)
    this.changeState('petIndoorsOutdoors', newPetIndoorsOutdoors)
  }

  back(e) {
    e.preventDefault();
    this.props.onGoBack();
  }

  submit(e) {
    this.props.onHostProfileSubmit({
      lifestyle: {
        pets: this.state.pets.val,
        pet_types: this.state.petTypes.val,
        pet_types_other: this.state.petTypesOther.val,
        pet_indoors_outdoors: this.state.petIndoorsOutdoors.val,
        pets_notes: this.state.petsNotes.val,
        pet_hypoallergenic: this.state.petHypoallergenic.val
      }
    })
  }

  render() {
    const thisPage = P.PETS_PAGE;
    const { formatMessage } = this.props.intl;
    const content = this.props.content;
    const page = this.props.page;

    return (
      <div id={page} className='profile'>
        <Redirector this_page={thisPage} page={page} />

        <form onSubmit={this.submit}>
          <FormHeader title={content.pages.pets.title} icon={<Paw />} />

          <ProfileElementField
            childComponent={
              <div>
                <CheckboxOrRadioGroup
                  title={formatMessage(defaultMessages.clientHostPagesPetsLabelsPets)}
                  setName={'pets'}
                  type={'radio'}
                  checkBoxStyle={'radio-inline'}
                  controlFunc={e => this.changeState('pets', e.target.value == 'true')}
                  valid={this.state.pets.valid}
                  options={[
                    [formatMessage(defaultMessages.clientCommonAffirmative), 'true'],
                    [formatMessage(defaultMessages.clientCommonNegative), 'false']
                  ]}
                  selectedOptions={[String(this.state.pets.val)]} />
                {
                  String(this.state.pets.val) == 'true' &&
                  <div>
                    <ProfileElementField
                      childComponent={
                        <div>
                          <CheckboxOrRadioGroup
                            title={formatMessage(defaultMessages.clientHostPagesPetsLabelsPetTypes)}
                            setName={'petTypes'}
                            type={'checkbox'}
                            controlFunc={this.handlePetTypesSelection}
                            options={this.state.petTypesSelections}
                            valid={this.state.petTypes.valid}
                            selectedOptions={this.state.petTypes.val || []} />
                          {
                            this.state.petTypes.val.includes('Other') &&
                            <CustomFormGroup valid={this.state.petTypesOther.valid}>
                              <FormControl
                                id='petTypesOther'
                                type="text"
                                style={{ width: '100%' }}
                                componentClass="input"
                                placeholder={formatMessage(defaultMessages.clientCommonDetails)}
                                defaultValue={this.state.petTypesOther.val}
                                onChange={e => this.changeState(e.target.id, e.target.value)} />
                            </CustomFormGroup>
                          }
                        </div>
                      }
                    elementName='pet_types' />

                    <ProfileElementField
                      childComponent={
                        <>
                          <CheckboxOrRadioGroup
                            title={formatMessage(defaultMessages.clientHostPagesPetsLabelsPetIndoorsOutdoors)}
                            setName={'petIndoorsOutdoors'}
                            type={'radio'}
                            checkBoxStyle={'radio-inline'}
                            controlFunc={e => this.changeState('petIndoorsOutdoors', e.target.value)}
                            options={this.state.petIndoorsOutdoorsSelections}
                            valid={this.state.petIndoorsOutdoors.valid}
                            selectedOptions={[String(this.state.petIndoorsOutdoors.val)]} />

                          <Alert alert={content.pages.pets.indoors_outdoors_info} />

                        </>
                      }
                      elementName='pet_indoors_outdoors' />

                    <CheckboxOrRadioGroup
                      title={formatMessage(defaultMessages.clientHostPagesPetsLabelsPetHypoallergenic)}
                      setName={'petHypoallergenic'}
                      type={'radio'}
                      checkBoxStyle={'radio-inline'}
                      controlFunc={e => this.changeState('petHypoallergenic', e.target.value == 'true')}
                      valid={this.state.petHypoallergenic.valid}
                      options={[
                        [formatMessage(defaultMessages.clientCommonAffirmative), 'true'],
                        [formatMessage(defaultMessages.clientCommonNegative), 'false']
                      ]}
                    selectedOptions={[String(this.state.petHypoallergenic.val)]} />

                    <ProfileElementField
                      childComponent={
                        <CustomFormGroup valid={this.state.petsNotes.valid}>
                          <ControlLabel>{formatMessage(defaultMessages.clientHostPagesPetsLabelsComments)}</ControlLabel>
                          <FormControl
                            componentClass="textarea"
                            id='petsNotes'
                            placeholder=""
                            style={{ width: '100%' }}
                            defaultValue={this.state.petsNotes.val}
                            onChange={e => this.changeState(e.target.id, e.target.value)} />
                        </CustomFormGroup>
                      }
                      elementName='pets_notes' />
                  </div>
                }
              </div>
            }
            elementName='pets' />
          <Alert alert={content.pages.pets.info} />

          <ButtonGroup
            backFunc={this.back}
            submitFunc={this.submit}
            disableSubmit={!pageValid(this.state, this.props.requiredFields)}
            page={thisPage}
            user={this.props.user}
            intl={this.props.intl} />

        </form>
      </div>
    )
  }
}

Pets.propTypes = {
  onHostProfileSubmit: PropTypes.func,
  onSkipSubmit: PropTypes.func,
  onGoBack: PropTypes.func,
  page: PropTypes.string,
  intl: PropTypes.object,
  content: PropTypes.object
}

export default injectIntl(Pets)
